import EVENT_NAMES from './eventNames';

export default {
  Ready: new Event(EVENT_NAMES.READY),

  Active: new Event(EVENT_NAMES.ACTIVE),

  Inactive: new Event(EVENT_NAMES.INACTIVE),

  VehicleAdded(stockId) {
    return new CustomEvent(EVENT_NAMES.VEHICLE_ADDED, {
      detail: stockId,
    });
  },

  VehicleRemoved(stockId) {
    return new CustomEvent(EVENT_NAMES.VEHICLE_REMOVED, {
      detail: stockId,
    });
  },
};
